module.exports = __webpack_public_path__ + "static/logo-symbol.2a3bac02.svg";